import { _ as t } from "./_getNative.js";
import { _ as r } from "./_root.js";
var o = t, a = r, e = o(a, "Set"), i = e;
export {
  i as _
};
//# sourceMappingURL=_Set.js.map
